var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYachtTrack = function SvgYachtTrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 16 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12h-2a1 1 0 0 0 0 2h.91A6 6 0 0 1 9 18.91V10h1a1 1 0 1 0 0-2H9V6.82a3 3 0 1 0-2 0V8H6a1 1 0 0 0 0 2h1v8.91A6 6 0 0 1 2.09 14H3a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1 8 8 0 1 0 16 0 1 1 0 0 0-1-1ZM8 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
  })));
};
export default SvgYachtTrack;